import { useAuth } from "@/components/auth/AuthProvider";
import { LoggedInHero } from "./LoggedInHero";
import { HeroSection } from "../hero/HeroSection";

export function Hero() {
  const { user } = useAuth();

  if (user) {
    return <LoggedInHero />;
  }

  return (
    <section className="relative flex flex-col items-center justify-center w-full">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(120,119,198,0.1),rgba(255,255,255,0))]" />
      
      <div className="relative z-10 w-full">
        <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
          <HeroSection />
        </div>
      </div>
    </section>
  );
}